<div class="card border-0 shadow-sm d-flex flex-column" dropFile (files)="fileUploadModalService.filesDropped($event)" style="max-height: 90vh;">
    <div class="card-header text-light border-0 bg-secondary flex-shrink-0">
        Upload Files
    </div>
    <div class="card-body overflow-auto flex-grow-1" style="min-height: 40vh;">
        <div class="card shadow my-2 p-2 border-warning">
            <div class="table-responsive admin-content">
                <!-- <span>{{fileUploadProgress|json}}</span> -->
                <table class="table table-stripped">
                    <thead class="table-light">
                        <tr >
                            <th scope="col" class="border-0 col-5">File Name</th>
                            <th scope="col" class="border-0">Progress</th>
                            <th scope="col" class="border-0 col-1">Size</th>
                            <th scope="col" class="border-0">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let file of files; index as i">
                            <td>
                                <span
                                [matTooltip]="file.name"
                                matTooltipPosition="above">{{file.name | maxchar:60}}</span>
                            </td>
                            <td>
                                <div class="d-flex">
                                    <span class="progress col-11" *ngIf="!fileUploadErrors[file.name]">
                                        <span class="progress-bar" role="progressbar" [ngStyle]="{'width':(fileUploadProgress[file.name]+'%')}" [attr.aria-valuenow]="fileUploadProgress[file.name]" aria-valuemin="0" aria-valuemax="100">
                                            <span *ngIf="fileUploadProgress[file.name] > 1" class="ps-3 ms-3 position-absolute start-50 translate-middle-x text-nowrap">
                                                    {{fileUploadProgress[file.name]}}%
                                            </span>
                                        </span>
                                    </span>
                                    <span class="progress col-11" *ngIf="fileUploadErrors[file.name]">
                                        <span class="progress-bar bg-danger text-light" role="progressbar" [ngStyle]="{'width':'100%'}" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">
                                            {{this.fileUploadErrors[file.name]}}
                                        </span>
                                    </span>
                                    <span class="col-1">
                                        <i class="fa-solid fa-circle-check text-success ms-1" *ngIf="fileUploadProgress[file.name] == 100"></i>
                                    </span>
                                </div>
                            </td>
                            <td>
                                {{util.formatBytes(file.size)}}
                            </td>
                            <td>
                                <!-- disable if file upload is in progress -->
                                <i class="fa-duotone fa-rotate-right" (click)="retryUpload(file)" *ngIf="fileUploadErrors[file.name] && !file.isUploading && !isRetry"></i>
                                <i class="fa-duotone fa-rotate-right fa-spin" *ngIf="canShowRetrySpinner(file)"></i>
                                <i class="fas fa-trash ms-2 text-danger" (click)="deleteFile(file)" *ngIf="canShowDeleteButton(file)" style="cursor: pointer;"></i>
                                <!-- <i class="ms-3 fas fa-download"></i> -->
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="card shadow my-2 p-2 add-more-files" (click)="addMoreFiles.click()">
            <div class="text-center">
                <i class="fas fa-plus"></i> Add More Files
                <input #addMoreFiles hidden multiple type="file" (change)="onFilesAdded($event)"/>
            </div>
        </div>

        <div class="card shadow my-2 p-2 border-warning">
            <div class="row">
                <!-- <div class="col-md-4">
                    <span class="mt-5 pt-4 fs-5">
                        Category
                    </span>
                </div> -->
                <div class="col-md-12">
                    <div class="m-2 text-center">
                        <mat-radio-group [(ngModel)]="category" aria-label="Select an option">
                            <mat-radio-button class="ms-3" value="SR" *ngIf="('SR'|auth)">SR</mat-radio-button>
                            <mat-radio-button class="ms-3" value="SPED" *ngIf="('SPED'|auth)">SPED</mat-radio-button>
                            <mat-radio-button class="ms-3" value="ER" *ngIf="('HR'|auth)">ER</mat-radio-button>
                            <mat-radio-button class="ms-3" value="AR" *ngIf="('AR'|auth)">AR</mat-radio-button>
                          </mat-radio-group>
                    </div>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-md-6">
                    <button class="btn w-100" 
                        (mouseover)="isSinglePersonHovering = true" 
                        (mouseout)="isSinglePersonHovering = false" 
                        [class.c-border-warning]="isSinglePersonHovering" 
                        [class.border-secondary]="singlePerson!=1 && !isSinglePersonHovering"
                        [class.btn-warning]="singlePerson==1" 
                        (click)="singlePerson=1">
                        <i class="fas fa-user fa-2x"></i> <br>
                        Single Person
                    </button>
                    <div class="mt-3">
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item">
                                <i class="fas fa-angle-right"></i> The documents in this batch must belong to <u>only one person</u>.
                            </li>
                            <li class="list-group-item">
                                <i class="fas fa-angle-right"></i> Different document types must be a separate file in order to upload to the correct folder.
                            </li>
                            <li class="list-group-item">
                                <i class="fas fa-angle-right"></i> The first page of each document determines the folder it will be filed in.
                            </li>
                            <li class="list-group-item">
                                <i class="fas fa-angle-right"></i> The system does not split persons or documents from within a single file.
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6">
                    <button class="btn w-100" 
                        (mouseover)="isMultiPersonHovering = true" 
                        (mouseout)="isMultiPersonHovering = false" 
                        [class.c-border-warning]="isMultiPersonHovering" 
                        [class.border-secondary]="singlePerson!=2 && !isMultiPersonHovering" 
                        [class.btn-warning]="singlePerson==2"
                        (click)="singlePerson=2">
                        <i class="fas fa-users fa-2x"></i> <br>
                        Multiple Person
                    </button>
                    <div class="mt-3">
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item">
                                <i class="fas fa-angle-right"></i> The documents in this batch belong to <u>more than one person</u>.
                            </li>
                            <li class="list-group-item">
                                <i class="fas fa-angle-right"></i> Each person with different document types must be a separate file to upload into the correct person and folder.
                            </li>
                            <li class="list-group-item">
                                <i class="fas fa-angle-right"></i> The system does not split persons or documents from within a single file.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>



    <div class="card-footer border-0 flex-shrink-0">
       <span class="float-end">
        <button class="btn btn-warning btn-sm text-light" [disabled]="disableUpload() || isFileUploaded || singlePerson==0" (click)="upload()">
            Upload &nbsp; <span *ngIf="isFileUploading"><i class="fas fa-circle-notch fa-spin"></i></span>
        </button>
        <button class="ms-2 btn btn-secondary btn-sm text-light" [disabled]="isFileUploading" (click)="dialogRef.close()">
            Close
        </button>
       </span>
    </div>
</div>